import Vue from 'vue';

const LocationBasedMixin = Vue.extend({
    props: {
        location: {
            type: String,
            required: true,
        }
    },
    methods: {
        // tslint:disable-next-line:no-empty
        async locationChanged(newLocation: string, oldLocation: string) { }
    },
    watch: {
        location(newLocation, oldLocation) {
            this.locationChanged(newLocation, oldLocation);
        }
    }
});

export default LocationBasedMixin;
